// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   services: [],
//   filteredServices: [],
//   displayedServices: [],
//   initialValue: {
//     serviceName: '',
//     category: '',
//     duration: '',
//     price: 0,
//     serviceFor: '',
//     mappedProducts:[],
//   },
//   serviceOptions: [{ name: 'Male' }, { name: 'Female' }, { name: 'Both' }],
//   filters: {
//     serviceFor: '',
//     search: '',
//   },
//   pagination: {
//     currentPage: 1,
//     itemsPerPage: 10,
//     totalItems: 0,
//     totalPages: 1,
//   },
// };

// const serviceSlice = createSlice({
//   name: 'services',
//   initialState,
//   reducers: {
//     updateServiceInState: (state, action) => {
//       const updatedService = action.payload;
//       state.services = state.services.map(service =>
//         service._id === updatedService._id ? updatedService : service
//       );
      
//       // Update filtered services without resetting pagination
//       state.filteredServices = state.filteredServices.map(service =>
//         service._id === updatedService._id ? updatedService : service
//       );
      
//       // Update displayed services without resetting page
//       updateDisplayedServices(state);
//     },
//     setAllServices(state, action) {
//       state.services = action.payload;
//       applyFilters(state);
//     },

//     updateServiceData(state, action) {
//       console.log(action.payload,'reduxSerrrrrrrrrr')
//       state.initialValue = ({ ...state.initialValue , ...action.payload });
//     },

//     updateSingleServiceField(state, action) {
//       const { name, value } = action.payload;
//       state.initialValue[name] = value;
//     },

//     clearServiceData(state) {
//       state.initialValue = initialState.initialValue;
//     },

//     setSearchFilter(state, action) {
//       state.filters.search = action.payload.toLowerCase();
//       applyFilters(state);
//     },

//     setServiceForFilter(state, action) {
//       state.filters.serviceFor = action.payload;
//       applyFilters(state);
//     },

//     setItemsPerPage(state, action) {
//       state.pagination.itemsPerPage = action.payload;
//       state.pagination.currentPage = 1;
//       applyFilters(state);
//     },

//     setCurrentPage(state, action) {
//       state.pagination.currentPage = action.payload;
//       updateDisplayedServices(state);
//     },

//     resetFilters(state) {
//       state.filters = {
//         serviceFor: '',
//         search: '',
//       };
//       state.pagination.itemsPerPage = 10;
//       applyFilters(state);
//     },
//   },
// });

// // Helper functions
// function applyFilters(state) {
//   const { search, serviceFor } = state.filters;
//   const { services } = state;

//   let filtered = [...services];

//   // if (search) {
//   //   filtered = filtered.filter((item) => item?.serviceName?.toLowerCase().includes(search));
//   // }
//     if (search) {
//     const searchLower = search.toLowerCase();
//     filtered = filtered.filter(
//       (item) =>
//         item?.serviceName?.toLowerCase().includes(searchLower) ||
//         item?.category?.toLowerCase().includes(searchLower) // ✅ category search
//     );
//   }

//   if (serviceFor) {
//     filtered = filtered.filter((item) => item?.serviceFor === serviceFor);
//   }

//   state.filteredServices = filtered;
  
//   state.pagination.totalItems = filtered.length;
//   state.pagination.totalPages = Math.ceil(filtered.length / state.pagination.itemsPerPage) || 1;

//   updateDisplayedServices(state);
// }

// function updateDisplayedServices(state) {
//   const { currentPage, itemsPerPage } = state.pagination;
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;

//   state.displayedServices = state.filteredServices.slice(startIndex, endIndex);
// }

// export const {
//   updateServiceInState,
//   setAllServices,
//   updateServiceData,
//   updateSingleServiceField,
//   clearServiceData,
//   setSearchFilter,
//   setServiceForFilter,
//   setItemsPerPage,
//   setCurrentPage,
//   resetFilters,
// } = serviceSlice.actions;

// export default serviceSlice.reducer;


//new filter
// src/redux/slices/servicesSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  services: [],
  filteredServices: [],
  displayedServices: [],
  initialValue: {
    serviceName: '',
    category: '',
    duration: '',
    price: 0,
    serviceFor: '',
    mappedProducts: [],
  },
  serviceOptions: [{ name: 'Male' }, { name: 'Female' }, { name: 'Both' }],
  filters: {
    serviceFor: '',
    search: '',
    category: '',
  },
  pagination: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 1,
  },
};

const serviceSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    updateServiceInState: (state, action) => {
      const updatedService = action.payload;
      state.services = state.services.map((s) =>
        s._id === updatedService._id ? updatedService : s
      );

      // Update filtered list too
      state.filteredServices = state.filteredServices.map((s) =>
        s._id === updatedService._id ? updatedService : s
      );

      // Recompute displayed slice (keeping page if possible)
      applyFilters(state);
    },

    setAllServices(state, action) {
      state.services = action.payload || [];
      // whenever full list changes, reset page to 1
      state.pagination.currentPage = 1;
      applyFilters(state);
    },

    updateServiceData(state, action) {
      state.initialValue = { ...state.initialValue, ...action.payload };
    },

    updateSingleServiceField(state, action) {
      const { name, value } = action.payload;
      state.initialValue[name] = value;
    },

    clearServiceData(state) {
      state.initialValue = initialState.initialValue;
    },

    setSearchFilter(state, action) {
      state.filters.search = (action.payload || '').toString().toLowerCase();
      state.pagination.currentPage = 1;
      applyFilters(state);
    },

    setServiceForFilter(state, action) {
      state.filters.serviceFor = action.payload || '';
      state.pagination.currentPage = 1;
      applyFilters(state);
    },

    setCategoryFilter(state, action) {
      state.filters.category = action.payload || '';
      state.pagination.currentPage = 1;
      applyFilters(state);
    },

    setItemsPerPage(state, action) {
      state.pagination.itemsPerPage = Number(action.payload) || 10;
      state.pagination.currentPage = 1;
      applyFilters(state);
    },

    setCurrentPage(state, action) {
      state.pagination.currentPage = Number(action.payload) || 1;
      updateDisplayedServices(state);
    },

    resetFilters(state) {
      state.filters = { serviceFor: '', search: '', category: '' };
      state.pagination.itemsPerPage = 10;
      state.pagination.currentPage = 1;
      applyFilters(state);
    },
  },
});

// Helper functions
function applyFilters(state) {
  const { search = '', serviceFor = '', category = '' } = state.filters || {};
  const { services } = state;

  let filtered = [...(services || [])];

  // search — search across serviceName and category values (case-insensitive)
  if (search && search.trim() !== '') {
    const searchLower = search.toString().toLowerCase();
    filtered = filtered.filter(
      (item) =>
        (item?.serviceName || '').toString().toLowerCase().includes(searchLower) ||
        (item?.category || '').toString().toLowerCase().includes(searchLower)
    );
  }

  if (serviceFor) {
    filtered = filtered.filter((item) => (item?.serviceFor || '') === serviceFor);
  }

  if (category) {
    filtered = filtered.filter((item) => (item?.category || '') === category);
  }

  state.filteredServices = filtered;
  state.pagination.totalItems = filtered.length;
  state.pagination.totalPages =
    Math.max(1, Math.ceil(filtered.length / (state.pagination.itemsPerPage || 10)));

  // clamp currentPage if out of range
  if (state.pagination.currentPage > state.pagination.totalPages) {
    state.pagination.currentPage = state.pagination.totalPages;
  }
  if (state.pagination.currentPage < 1) {
    state.pagination.currentPage = 1;
  }

  updateDisplayedServices(state);
}

function updateDisplayedServices(state) {
  const { currentPage = 1, itemsPerPage = 10 } = state.pagination;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  state.displayedServices = (state.filteredServices || []).slice(startIndex, endIndex);
}

export const {
  updateServiceInState,
  setAllServices,
  updateServiceData,
  updateSingleServiceField,
  clearServiceData,
  setSearchFilter,
  setServiceForFilter,
  setItemsPerPage,
  setCurrentPage,
  resetFilters,
  setCategoryFilter,
} = serviceSlice.actions;

export default serviceSlice.reducer;


//according to new ui 
// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   services: [],
//   filteredServices: [],
//   displayedServices: [],
//   initialValue: {
//     serviceName: '',
//     category: '',
//     duration: '',
//     price: 0,
//     serviceFor: '',
//     mappedProducts:[],
//   },
//   serviceOptions: [{ name: 'Male' }, { name: 'Female' }, { name: 'Both' }],
//   filters: {
//     serviceFor: '',
//     search: '',
//   },
//   pagination: {
//     currentPage: 1,
//     itemsPerPage: 10,
//     totalItems: 0,
//     totalPages: 1,
//   },
// };

// const serviceSlice = createSlice({
//   name: 'services',
//   initialState,
//   reducers: {
//     updateServiceInState: (state, action) => {
//       const updatedService = action.payload;
//       state.services = state.services.map(service =>
//         service._id === updatedService._id ? updatedService : service
//       );
      
//       // Update filtered services without resetting pagination
//       state.filteredServices = state.filteredServices.map(service =>
//         service._id === updatedService._id ? updatedService : service
//       );
      
//       // Update displayed services without resetting page
//       updateDisplayedServices(state);
//     },
//     setAllServices(state, action) {
//       state.services = action.payload;
//       applyFilters(state);
//     },

//     updateServiceData(state, action) {
//       console.log(action.payload,'reduxSerrrrrrrrrr')
//       state.initialValue = ({ ...state.initialValue , ...action.payload });
//     },

//     updateSingleServiceField(state, action) {
//       const { name, value } = action.payload;
//       state.initialValue[name] = value;
//     },

//     clearServiceData(state) {
//       state.initialValue = initialState.initialValue;
//     },

//     setSearchFilter(state, action) {
//       state.filters.search = action.payload.toLowerCase();
//       applyFilters(state);
//     },

//     setServiceForFilter(state, action) {
//       state.filters.serviceFor = action.payload;
//       applyFilters(state);
//     },

//     setItemsPerPage(state, action) {
//       state.pagination.itemsPerPage = action.payload;
//       state.pagination.currentPage = 1;
//       applyFilters(state);
//     },

//     setCurrentPage(state, action) {
//       state.pagination.currentPage = action.payload;
//       updateDisplayedServices(state);
//     },

//     resetFilters(state) {
//       state.filters = {
//         serviceFor: '',
//         search: '',
//       };
//       state.pagination.itemsPerPage = 10;
//       applyFilters(state);
//     },
//   },
// });

// // Helper functions
// function applyFilters(state) {
//   const { search, serviceFor } = state.filters;
//   const { services } = state;

//   let filtered = [...services];

//   if (search) {
//     const searchLower = search.toLowerCase();
//     filtered = filtered.filter(
//       (item) =>
//         item?.serviceName?.toLowerCase().includes(searchLower) ||
//         item?.category?.toLowerCase().includes(searchLower) ||
//         item?.serviceFor?.toLowerCase().includes(searchLower) || // Add gender search
//         item?.price?.toString().includes(search) // Add price search
//     );
//   }

//   if (serviceFor) {
//     filtered = filtered.filter((item) => item?.serviceFor === serviceFor);
//   }

//   state.filteredServices = filtered;
  
//   // Reset to page 1 when filters change
//   state.pagination.currentPage = 1;
//   state.pagination.totalItems = filtered.length;
//   state.pagination.totalPages = Math.ceil(filtered.length / state.pagination.itemsPerPage) || 1;

//   updateDisplayedServices(state);
// }

// function updateDisplayedServices(state) {
//   const { currentPage, itemsPerPage } = state.pagination;
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;

//   state.displayedServices = state.filteredServices.slice(startIndex, endIndex);
// }

// export const {
//   updateServiceInState,
//   setAllServices,
//   updateServiceData,
//   updateSingleServiceField,
//   clearServiceData,
//   setSearchFilter,
//   setServiceForFilter,
//   setItemsPerPage,
//   setCurrentPage,
//   resetFilters,
// } = serviceSlice.actions;

// export default serviceSlice.reducer;

